import React, { Component } from 'react';
import BlockUI from 'react-block-ui';
import PropTypes from 'prop-types';
import { Button } from 'Components/Button';
import { classnames } from 'Utils/classnames';
import EnvironmentManager from 'Utils/environmentManager';
import LottieLoader from 'Components/LottieLoader';

class SelectSystem extends Component {

  static propTypes = {
    activeSystems: PropTypes.array,
    handleSystemSelection: PropTypes.func.isRequired,
    availableSystems: PropTypes.array,
    betSlip: PropTypes.object,
    validateBetSlip: PropTypes.func,
    closeModal: PropTypes.func,
    handleSystemModalClosable: PropTypes.func,
    columnCount: PropTypes.number,
    isLoading: PropTypes.bool
  };

  constructor (props) {
    super(props);
    this.COLUMN_COUNT_WARNING = EnvironmentManager.getParameter('system_columncount_warning_message');
    this.COLUM_COUNT_LIMIT = EnvironmentManager.getParameter('TM_MAX_STAKE') || 2500;
    this.state = {
      activeSystems: props.activeSystems || [],
      isModalBig: false
    };
  }

  onSystemClick = clickedSystem => {
    const { betSlip: { coupon: { bets } } } = this.props;
    let newSystems = [...this.state.activeSystems];

    if (newSystems.includes(clickedSystem)) {
      newSystems = newSystems.filter(system => system !== clickedSystem);
    } else {
      newSystems.push(clickedSystem);
    }

    const sortedSystems = newSystems.sort();
    const bankerCount = bets.filter(b => b.banker).length;
    let activeSystems = null;

    if (sortedSystems.length === 1 && sortedSystems[0] === bankerCount) {
      activeSystems = [sortedSystems[0], bets.length];
    } else {
      activeSystems = sortedSystems;
    }
    
    this.setState({ activeSystems });
    this.props.handleSystemSelection(activeSystems);
  };

  componentDidMount () {
    const { columnCount, availableSystems } = this.props;

    if (this.props.columnCount > this.COLUM_COUNT_LIMIT) {
      this.props.handleSystemModalClosable(columnCount < this.COLUM_COUNT_LIMIT);

      if (availableSystems?.length > 6) {
        this.setState({
          isModalBig: true
        });
      }
    }
  }

  componentDidUpdate (prevProps) {
    const { columnCount, handleSystemModalClosable, availableSystems } = this.props;

    if (prevProps.columnCount !== columnCount) {
      handleSystemModalClosable(columnCount < this.COLUM_COUNT_LIMIT);

      this.setState({
        isModalBig: availableSystems?.length > 6 && columnCount > this.COLUM_COUNT_LIMIT
      });
    }
  }

  render () {
    const { activeSystems, isModalBig } = this.state;
    const { availableSystems, columnCount, isLoading } = this.props;
    const limitControl = columnCount > this.COLUM_COUNT_LIMIT;

    const blockUIClass = classnames({
      'block-ui--relative': true,
      'block-ui--theme-dark': true,
      'block-ui--select-system': true,
      'block-ui--select-system--big': isModalBig
    });

    return (
      <BlockUI
        tag="div"
        className={ blockUIClass }
        blocking={ isLoading }
        loader={ <LottieLoader type="loading" loop={ true } autoplay width="75px" /> }
        renderChildren={ true }>
        <div className="select-system-modal">

          <div className="select-system-modal__systems">
            { availableSystems.map((mockSystem, index) => {
              return (
                <div
                  key={ index }
                  className={ classnames({
                    'select-system-modal__systems__system': true,
                    'select-system-modal__systems__system--active': activeSystems.includes(mockSystem)
                  }) }
                  onClick={ () => this.onSystemClick(mockSystem) }>
                  { mockSystem }
                </div>
              );
            }) }
          </div>

          <div className="select-system-modal__column">

            <div>
              <span>Kolon Sayısı:</span>
              <span className={ classnames({
                'select-system-modal__column-count': true,
                'select-system-modal__column-count--warning': limitControl
              }) }>&nbsp;{ columnCount }</span>
            </div>
            <span className="select-system-modal__warning">{ limitControl ? this.COLUMN_COUNT_WARNING : '' }</span>
          </div>

          <Button title={ 'TAMAM' } className={ classnames({
            'btn--primary': true,
            'btn--half-round': true,
            'btn--disabled': limitControl
          }) }
          onClick={ () =>  this.props.closeModal('selectSystemModal') }>
              TAMAM
          </Button>
        </div>
      </BlockUI>
    );
  }
}

export default SelectSystem;
